export type NavBadgeTone = "accent" | "success";

// 色は種類で分ける。accent は新機能・ベータ、success は「共有中」のような良好な状態（#1861）。
const TONE_CLASS: Record<NavBadgeTone, string> = {
  accent: "bg-accent",
  success: "bg-success",
};

export default function NavBadge({
  label,
  tone = "accent",
  placement = "corner",
  className = "",
}: {
  label: string;
  tone?: NavBadgeTone;
  /**
   * corner: ラベルやアイコンの右肩に重ねる（β / NEW のような1〜3文字向け）。
   * inline: ラベルの右に並べる。「共有中」のように幅のある文言を重ねると文字に被るため、
   *         展開したサイドメニューではこちらを使う。
   */
  placement?: "corner" | "inline";
  className?: string;
}) {
  // 右肩に重ねる極小バッジは 9px。ラベルの右に並べるものは文字として読むため一段大きくする
  const position = placement === "corner" ? "absolute text-[9px]" : "ml-2 shrink-0 text-[11px]";
  return (
    <span
      aria-hidden="true"
      className={`${position} ${TONE_CLASS[tone]} text-white font-extrabold rounded leading-tight tracking-wide ${className}`}
    >
      {label}
    </span>
  );
}
